import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";

const ProductDetail = ({ open, handleClose, product }) => {
  if (!product) return null;

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>{product.name}</DialogTitle>
      <DialogContent>
        {/* <img
          src={product.image}
          alt={product.name}
          style={{ width: "100%", borderRadius: 10 }}
        /> */}
           <Box display="flex" gap={2} flexWrap="wrap" mb={2}>
          {product.images?.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`product-${index}`}
              style={{
                width: "120px",
                height: "120px",
                objectFit: "cover",
                borderRadius: 8,
              }}
            />
          ))}
        </Box>

        <Box mt={2}>
          <Typography>Description: {product.description}</Typography>
          <Typography>Price: ₹ {product.price}</Typography>
          <Typography>Category: {product.category}</Typography>
          <Typography>Sizes: {product.sizes.join(", ")}</Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ProductDetail;
